import { AuthConfigState } from '../defaults/authConfig';

export const SET_AUTH_CONFIG = 'APP_SET_AUTH_CONFIG';

export function setAuthConfig(config: Partial<AuthConfigState>) {
  return {
    type: SET_AUTH_CONFIG,
    config,
  };
}
